import React,  { useEffect , useState } from 'react'
import styled from 'styled-components'
import { Heading, Text, BaseLayout } from '@pancakeswap-libs/uikit'
import useI18n from 'hooks/useI18n'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Page from 'components/layout/Page'
import VisionCard from 'views/Home/components/VisionCard'
import TotalValueLockedCard from 'views/Home/components/TotalValueLockedCard'
import EarnAPYCard from 'views/Home/components/EarnAPYCard'
import FarmStakingCard from './components/FarmStakingCard'
import CakeStats from './components/CakeStats'
import NFTDetailsCard from './components/NFTDetailsCard'
import LotteryDetailCard from './components/LotteryDetailCard'

const Hero = styled.div`
  align-items: center;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  margin-bottom: 10px;
  padding-top: 0;
  text-align: center;
  word-break: break-word;

  ${({ theme }) => theme.mediaQueries.lg} {
    // background-image: url('/images/left_img.png'), url('/images/right_img.png');
    background-position: left center, right center;
    // height: 210px;
    padding-top: 0;
    margin-bottom: -10px;
  }
`

const Cards = styled(BaseLayout)`
  align-items: stretch;
  justify-content: stretch;
  margin-bottom: 32px;

  & > div {
    grid-column: span 6;
    width: 100%;
  }

  @media screen and (max-width: 967px) {
    & > div:first-child {
      margin-bottom: 16px;
    }
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    & > div {
      grid-column: span 8;
    }
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    & > div {
      grid-column: span 6;
    }
  }
`
const CardsLarge = styled(BaseLayout)`
  align-items: stretch;
  justify-self: center;
  margin-bottom: 32px;

  & > div {
    grid-column: span 12;
    width: 100%;
    text-align: center;

  }
`

const Row = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 30px 0 30px;
  width: 100%;

  @media screen and (max-width: 539px) {
    display: block;
  }
`


const Home: React.FC = () => {
  const TranslateString = useI18n()
  const [copy, setCopy] = useState<boolean>(false)
  useEffect(()=>{
    setTimeout(function() {
         setCopy(false)
         }, 3000);
       },[copy]);

  return (
    <div className="home_page">
      <Page>
        <Hero>
          <Heading as="h1" mb="10px" className="dash_heading" style={{ fontSize: "40px", display:"flex", alignItems: "center" }}>
            {TranslateString(576, 'A HYPER DEFLATIONARY REWARDS TOKEN')}
          </Heading>
          <Text mt="5px" className="dash_subheading" color="secondary">{TranslateString(578, "The first Suriname Token running on Binance Smart Chain")}</Text>
          {/* <Text mt="5px" className="dash_subheading" color="secondary">{TranslateString(578, "Inspired by Cake, but Sweeter")}</Text> */}
          <p className="dash_subheading mt-3" color="secondary">Our official contract address:
          <span>  0x84Fd7CC4Cd689fC021eE3D00759B6D255269D538</span>
           <CopyToClipboard  onCopy={() => setCopy(true)} Tooltip={{ title: "Copied!" }} text="0x84Fd7CC4Cd689fC021eE3D00759B6D255269D538">
             <i className="fas fa-copy"/>
           </CopyToClipboard>
           {copy ? <span style={{color: 'green',float :'right',marginLeft : '10px' }}> Copied!.</span> : null}
          </p>

          {/* <Row className="img_row">
            <img src="/images/banner_logo_01.png" alt="Icon" style={{marginLeft:"8px", marginBottom:"15px"}} />
            <img src="/images/banner_logo_02.png" alt="Icon" style={{marginLeft:"8px", marginBottom:"15px"}} />
            <img src="/images/banner_logo_03.png" alt="Icon" style={{marginLeft:"8px", marginBottom:"15px"}} />
            <img src="/images/banner_logo_04.png" alt="Icon" style={{marginLeft:"8px", marginBottom:"15px"}} />
            <img src="/images/banner_logo_05.png" alt="Icon" style={{marginLeft:"8px", marginBottom:"15px"}} />
            <img src="/images/banner_logo_06.png" alt="Icon" style={{marginLeft:"8px", marginBottom:"15px"}} />
          </Row> */}
        </Hero>
        <div>
          <CardsLarge>
            <VisionCard />
          </CardsLarge>
          <Cards>
            <CakeStats />
            <NFTDetailsCard />
          </Cards>
          <CardsLarge>
            <LotteryDetailCard/>
          </CardsLarge>
          <Cards>
            <FarmStakingCard />
            <TotalValueLockedCard />
          </Cards>
        </div>
      </Page>
    </div>
  )
}

export default Home
